import React, { useState, useMemo, useEffect, useCallback } from 'react';
import CustomTable from 'components/CustomTable/CustomTable';
import { translate } from 'components/Translation';
import { PhoneNumberCell } from 'components/Cells/Cells';
import Add from '@material-ui/icons/Add';
import TableHeader from 'components/TableHeader/TableHeader';
import CardButtons from 'views/PrepaidLoyalty/RegisteringNewLoyalty/components/CardButtons';
import Button from 'components/CustomButtons/Button';
import { exportToXLS } from 'utils/export/export';
import moment from 'moment';

interface INumbersTable {
	numbers: string[];
	removeNumbers: (numbers: string[]) => void;
	showAddNumbersDialog: () => void;
	showUploadNumbersFromFileDialog: () => void;
	buttons: types.prepaidLoyalty.IButton[];
}

const NumbersTable = ({
	numbers,
	showAddNumbersDialog,
	showUploadNumbersFromFileDialog,
	buttons,
	removeNumbers,
}: INumbersTable) => {
	const [selected, setSelected] = useState<string[]>([]);
	const [searchValue, setSearchValue] = useState<string>('');

	const filteredNumbers = useMemo(() => {
		return numbers.filter((number) => number.includes(searchValue));
	}, [searchValue, numbers]);

	useEffect(() => {
		setSelected([]);
	}, [searchValue]);

	const deleteNumbers = () => {
		removeNumbers((selected || []).map((index) => numbers[index]));
		setSelected([]);
	};

	const exportToXls = useCallback(() => {
		const dataNumbers = (selected || []).map((index) => {
			return {
				Number: filteredNumbers[index],
			};
		});
		exportToXLS(dataNumbers, `numbers ${moment().format('LLL')}`);
	}, [filteredNumbers, selected]);

	return (
		<div>
			<TableHeader
				searchInputValue={searchValue}
				setSearchInputValue={(value) => setSearchValue(value)}
				dropdown={{
					action: 'all',
					menu: (
						<Button color="tertiary-light" withIcon>
							<>
								<Add />
								{translate('prepaid.loyalty.add.lines')}
							</>
						</Button>
					),
					items: [
						{
							text: translate('prepaid.loyalty.add.new.numbers'),
							onClick: showAddNumbersDialog,
						},
						{ text: translate('prepaid.loyalty.import'), onClick: showUploadNumbersFromFileDialog },
					],
				}}
			/>
			<CustomTable
				withCheckbox
				withHeader
				selected={selected}
				onSelect={setSelected}
				total={filteredNumbers.length}
				tableProps={{
					data: filteredNumbers,
					columns: [
						{
							Header: translate('phoneNumber'),
							accessor: '',
							// eslint-disable-next-line react/display-name
							Cell: ({ original }: { original: string }) => <PhoneNumberCell text={original} bold />,
							sortable: true,
						},
					],
					defaultPageSize: 10,
				}}
				selectPanel={{
					selectedElements: selected.length,
					deleteItems: deleteNumbers,
					downloadMenuItems: [
						{
							name: 'XSLX',
							onClick: exportToXls,
						},
					],
				}}
			/>
			<CardButtons buttons={buttons} />
		</div>
	);
};

export default NumbersTable;
